import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../Context/AuthenticateProvider";

const PrivateRouter = () => {
  const { isAuthenticated } = useAuth();
  const location = useLocation();
  console.log("Private Router")
  if (!isAuthenticated) {
    return <Navigate to="/register" state={{ from: location }} replace />;
  }

  return <Outlet />;
};

export default PrivateRouter;